import React from 'react';

import ToggleContent from '@shared/v2/components/ToggleContent';

import BookingConditionsModal from '@/components/BookingConditionsModal';
import Link from '@/components/Link';
import Text from '@/components/Text';

const CancellationText = () => (
  <>
    <Text fontSize="xs">
      Cancellation fees of up to 100% apply unless you are entitled to a refund
      or alternative flight under the&nbsp;
      <Link.Text
        external
        href="https://www.jetstar.com/au/en/help/articles/australian-consumer-law-information"
        display="inline"
      >
        Australian Consumer Law
      </Link.Text>
      &nbsp;or&nbsp;
      <Link.Text
        external
        href="https://www.jetstar.com/au/en/terms-and-conditions"
        display="inline"
      >
        Conditions of Carriage
      </Link.Text>
      .&nbsp;
      <Link.Text
        external
        href="https://www.jetstar.com/au/en/terms-and-conditions"
        display="inline"
      >
        Jetstar Conditions of Carriage
      </Link.Text>
      &nbsp;and&nbsp;
      <ToggleContent
        toggle={(open) => (
          <Text bold link onClick={open} fontSize="xs">
            Jetstar Holidays Booking Conditions
          </Text>
        )}
        content={(close) => <BookingConditionsModal close={close} />}
      />
      &nbsp;apply. We will do our best to get you where you want to be on time,
      but we don’t guarantee flight times or schedules and they aren’t part of
      our contract with you.
    </Text>
  </>
);

export default CancellationText;
